'use strict';

import Cookies from 'js-cookie';

const $popup = $('.js-popup');
const $popupClose = $('.js-popup-close');
const popupDelay = 2000;

function initialize() {

    if (Cookies.get('popup')) {
        $popup.remove();
        return false;
    }

    showPopup();

    $popupClose.on('click', function (e) {
        e.preventDefault();
        removePopup();
    });
}

function showPopup() {

    setTimeout( function () {

        $popup.slideUp('200', function() {
            $popup.fadeIn();
        });

    }, popupDelay);

}

function removePopup() {
    $popup.fadeOut('200', function() {
        $popup.remove();
        Cookies.set('popup', true, { expires: 1 });
    });
}

initialize();
